
import React from 'react';
import {CalendarIcon} from '../icons/CalendarIcon';
import 'react-datepicker/dist/react-datepicker.css';

const ReactDatePickerInput = React.forwardRef((props, ref) => {
    return (
        <div className="date-wrapper">
            <input onClick={props.onClick} className="dateInput" {...props} type="text" ref={ref} />
            <i className="calendar" onClick={props.onClick}>
                <CalendarIcon />
            </i>
        </div>
    );
});
ReactDatePickerInput.displayName = 'ReactDatePickerInput';
export default ReactDatePickerInput;

